import React from 'react';
import {formatPrice, i18n} from '../utils';
import {CHECKOUT_TYPE_QR, PAYMENT_TYPE_POINTS} from '../constants';
import Select from 'react-select';
import shoppingBag from '../assets/shopping-bag.svg';
import lock from '../assets/lock.svg';
import ReactImageMagnify from 'react-image-magnify';
import Clock from './Clock';

i18n.initialize();

export const CheckoutPaymentButtonBox = ({ product, quantity, paymentType, conversion, onChangeQuantity }) => {
  i18n.changeLanguage(localStorage.getItem('productLanguage'));

  const smallWidth = 299;
  const largeWidth = 750;
  const [ smallHeight, setSmallHeight ] = React.useState(0)
  const [ largeHeight, setLargeHeight ] = React.useState(0)

  const setHeight = (src, maxWidth, size) => {
    var original = new Image();
    var height = 0;
    original.onload = function() {
      var percentage = parseFloat(original.width) / maxWidth;
      height = Math.round(original.height / percentage);

      if (size == 'large') {
        setLargeHeight(height);
      } else {
        setSmallHeight(height);
      }
    }

    original.src = src;
  }

  const MAX_ELEMENTS = 99;
  const productCount = product.maxElements === null ? MAX_ELEMENTS : parseInt(product.maxElements);

  setHeight(product.image, smallWidth, 'small')
  setHeight(product.image, largeWidth, 'large')

  return (
    <div className="checkout-data checkout-data--button">
      {
        product.image
          && (
            <div className="checkout-data__image">
              <ReactImageMagnify {...{
                smallImage: {
                  alt: product.name,
                  isFluidWidth: false,
                  width: smallWidth,
                  height: smallHeight,
                  src: product.image
                },
                largeImage: {
                  src: product.image,
                  width: largeWidth,
                  height: largeHeight
                },
                enlargedImageContainerClassName: 'image-popup',
                enlargedImageContainerDimensions: {
                  width: '100%',
                  height: '100%'
                }
              }} />
            </div>
          )
      }
      <div className="checkout-data__checkout-info checkout-info">
        <div className="checkout-info__item">
          <h2 className="checkout-info__name">{product.name}</h2>
        </div>
        <div className="checkout-info__item checkout-info__item--quantity">
          <span className="font-weight-bold">{ i18n.t('quantity') }</span>
          <span>
            <Select
              clearable={false}
              searchable={false}
              onChange={item => onChangeQuantity(item.value)}
              value={quantity}
              options={
                Array
                  .from((new Array(productCount)).keys())
                  .map(number => ({ value: number + 1, label: number + 1 }))
              }
            />
          </span>
        </div>
        {
          product.observations
            && (
              <div className="checkout-info__item checkout-info__item--observations">
                { product.observations }
              </div>
            )
        }
        <div className="checkout-info__item checkout-info__item--total">
          <span>{ i18n.t('Total') }</span>
          <CheckoutPrice product={product} quantity={quantity} conversion={conversion} paymentType={paymentType} />
        </div>
      </div>
    </div>

  );
}

export const CheckoutOrderDataBox = ({ product, quantity, paymentType, conversion }) => {
  return (
    <React.Fragment>
      <div className="checkout-data checkout-data--order">
        <div className="checkout-data__icon">
          <img src={shoppingBag} height="32" width="32" />
        </div>
        <div className="checkout-data__checkout-info checkout-info">
          <div className="checkout-info__item checkout-info__item--total">
            <span>{ i18n.t('total_amount') }</span>
            <CheckoutPrice product={product} quantity={quantity} conversion={conversion} paymentType={paymentType} />
          </div>
          {
            product.items && product.items.map(item => (
              <div className="checkout-info__item" key={item.id}>
                <span>{item.name} x {item.quantity}</span>
                <span>{formatPrice(item.amount, product.currencySymbol)}</span>
              </div>
            ))
          }
        </div>
      </div>
      <div className="d-none d-lg-block">
      <p className="d-flex align-items-center">
        <img src={lock} className="d-inline-block mr-2" />
        <span>{ i18n.t('secure_transactions') }</span>
      </p>
      <p>{ i18n.t('stock_warning') }</p>

      </div>
    </React.Fragment>
  );
}
export const CheckoutQrBox = ({ product, quantity, paymentType, conversion, onChangeQuantity }) => {
  i18n.changeLanguage(localStorage.getItem('productLanguage'));

  const smallWidth = 299;
  const largeWidth = 750;
  const [ smallHeight, setSmallHeight ] = React.useState(0)
  const [ largeHeight, setLargeHeight ] = React.useState(0)

  const setHeight = (src, maxWidth, size) => {
    var original = new Image();
    var height = 0;
    original.onload = function() {
      var percentage = parseFloat(original.width) / maxWidth;
      height = Math.round(original.height / percentage);

      if (size == 'large') {
        setLargeHeight(height);
      } else {
        setSmallHeight(height);
      }
    }

    original.src = src;
  }
  if(product.type === CHECKOUT_TYPE_QR){
    const MAX_ELEMENTS = 1;
  }
  else{
    const MAX_ELEMENTS = 99;
  }
  const productCount = product.maxElements === null ? MAX_ELEMENTS : parseInt(product.maxElements);

  setHeight(product.image, smallWidth, 'small')
  setHeight(product.image, largeWidth, 'large')

  return (
      <div className="checkout-data checkout-data--button">
        {
            product.image
            && (
                <div className="checkout-data__image">
                  <ReactImageMagnify {...{
                    smallImage: {
                      alt: product.name,
                      isFluidWidth: false,
                      width: smallWidth,
                      height: smallHeight,
                      src: product.image
                    },
                    largeImage: {
                      src: product.image,
                      width: largeWidth,
                      height: largeHeight
                    },
                    enlargedImageContainerClassName: 'image-popup',
                    enlargedImageContainerDimensions: {
                      width: '100%',
                      height: '100%'
                    }
                  }} />
                </div>
            )
        }
        <div className="checkout-data__checkout-info checkout-info">
          <div className="checkout-info__item">
            <h2 className="checkout-info__name">{product.name}</h2>
          </div>
          <div className="checkout-info__item checkout-info__item--quantity">
            <span className="font-weight-bold">{ i18n.t('quantity') }</span>
            <span>
            <Select
                clearable={false}
                searchable={false}
                onChange={item => onChangeQuantity(item.value)}
                value={quantity}
                options={
                  Array
                      .from((new Array(productCount)).keys())
                      .map(number => ({ value: number + 1, label: number + 1 }))
                }
            />
          </span>
          </div>
          {
              product.observations
              && (
                  <div className="checkout-info__item checkout-info__item--observations">
                    { product.observations }
                  </div>
              )
          }
          <div className="checkout-info__item checkout-info__item--total">
            <span>{ i18n.t('Total') }</span>
            <CheckoutPrice product={product} quantity={quantity} conversion={conversion} paymentType={paymentType} />
          </div>
        </div>
        <Clock
          expiredAt={product.expiredAt}
          />
      </div>

  );
}

const CheckoutPrice = ({product, quantity, conversion, paymentType}) => {
  const totalAmount = product.price * quantity;
  if(paymentType === PAYMENT_TYPE_POINTS) {
    return (
      conversion
        ? <span>{formatPrice(Math.ceil(totalAmount * (1 / conversion)), i18n.t('points'))}</span>
        : <span className="text-dark text-right small">{i18n.t('points_choose_loyalty')}</span>
    );

  }
  return <span>{formatPrice(totalAmount, product.currencySymbol)}</span>;
}

export default CheckoutPaymentButtonBox



// WEBPACK FOOTER //
// ./client/components/CheckoutBox.js